import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { arrowLeftIcon } from '@europrocurement/l2d-icons';
import { FlexyIconButton } from '../../atoms';

export type ToolbarPreviousActionProps = {
    path?: string;
};

export const ToolbarPreviousAction: React.FunctionComponent<ToolbarPreviousActionProps> = function (
    props,
) {
    const navigate = useNavigate();
    const { path } = props;

    return (
        <FlexyIconButton
            onClick={() => (path ? navigate(path) : navigate(-1))}
            icon={arrowLeftIcon}
        />
    );
};
